import type { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './StatusDot.module.scss';

export type StatusDotTone = 'success' | 'info' | 'caution' | 'warning' | 'danger' | 'neutral';

export interface StatusDotProps {
    tone: StatusDotTone;
    /** `sm` is the dot for small table text, such as the audit log's outcome column. */
    size?: 'sm' | 'md';
    /** The status in words, so the colour is never the only signal. */
    children: ReactNode;
    className?: string;
}

/** A coloured dot before a status label, for a list or table cell where a pill would crowd. */
export default function StatusDot(props: StatusDotProps) {
    const { tone, size = 'md', children, className } = props;

    return (
        <span className={classNames(styles.statusDot, size === 'sm' && styles.sm, className)}>
            <span className={styles.dot} data-tone={tone} aria-hidden="true" />
            <span className={styles.label}>{children}</span>
        </span>
    );
}

export { StatusDot };
